import { Navigate } from "react-router-dom";
import { useOrgAdminFeatures, type OrgAdminFeature } from "@/hooks/use-org-admin-features";
import { useRoleBasedAccess } from "@/hooks/use-role-based-access";

export const OrgFeatureGate = ({ feature, adminOnly = false, children }: { feature: OrgAdminFeature; adminOnly?: boolean; children: React.ReactNode }) => {
  const { isEnabled, isLoading } = useOrgAdminFeatures();
  const { isOrgAdmin, isSystemAdmin, isLoading: roleLoading } = useRoleBasedAccess();
  if (isLoading || roleLoading) return null;
  if (adminOnly && !isOrgAdmin && !isSystemAdmin) return <Navigate to="/dashboard" replace />;
  if (!isEnabled(feature)) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
};
